import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, Permission, UserType } from './auth.types';

export const initialState: AuthState = {
    jwt: null,
    refreshCode: null,
    validFor: 0,
    tokenExpiresAt: 0,
    userType: null,
    permissions: [],
    userId: null,
    liftOperatorData: null,
    logoutType: null,
};

export const authSlice = createSlice({
    name: 'authSlice',
    initialState: initialState,
    reducers: {
        setAuthData(
            state: AuthState,
            action: PayloadAction<{
                jwt: string;
                refreshCode: string;
                validFor: number;
                tokenExpiresAt: number;
                permissions: Permission[];
                userType: UserType;
                userId: string;
                liftOperatorData: {
                    skiOperator: string;
                    liftOperatorId: string;
                };
            }>
        ) {
            return {
                ...state,
                ...action.payload,
                logoutType: null,
            };
        },

        clearAuthData(
            _state: AuthState,
            action: PayloadAction<{ userLogout?: boolean }>
        ) {
            const userLogout = !!action.payload.userLogout;

            return {
                ...initialState,
                logoutType: userLogout ? 'userLogout' : null,
            };
        },
    },
});

export const authActions = {
    ...authSlice.actions,
};
